<template>
  <app-navigation :title="toolbarTitle">

    <v-layout :row="!mobileView" :column="mobileView" align-center class="mx-3 py-3">
      <student-fields :student="student" :redirectPath="path" />
      <datepicker v-model="dateSelected" :maxDate="new Date()" :minDate="minDate" />
    </v-layout>

    <meal-card
      :studentTrays="studentListTrays"
      :errorRequest="!!errorRequest"
      :loadingData="loadingRequest"/>
  </app-navigation>
</template>

<script>
import { mobileViewBreakpoint } from '@/helpers/mobileViewBreakpoint'
import Datepicker from '@/components/Datepicker'
import MealCard from '@/components/MealCard'
import StudentFields from '@/components/StudentFields'
import AppNavigation from '@/layouts/AppNavigation'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'StudentTray',

  components: {
    Datepicker,
    MealCard,
    AppNavigation,
    StudentFields
  },

  data: () => ({
    path: '/refeicoes/estudantes',
    dateSelected: {},
    toolbarTitle: 'Controle de Refeições'
  }),

  computed: {
    ...mapState({
      errorRequest: state => state.mealControl.errorRequest,
      loadingRequest: state => state.mealControl.loadingRequest,
      student: state => state.mealControl.student,
      studentListTrays: state => state.mealControl.listTrays
    }),

    minDate () {
      let today = new Date()
      return new Date(today.setDate(today.getDate() - 15))
    },

    mobileView () {
      return mobileViewBreakpoint(this.$vuetify.breakpoint.name)
    }
  },

  watch: {
    dateSelected (newValue) {
      if ((newValue || {}).start) {
        this.pushDatePeriod(newValue)
        this.getStudentTrays({ studentId: this.$route.params.id, ...this.getStudentParams() })
      }
    }
  },

  methods: {
    ...mapActions({
      getStudentTrays: 'mealControl/getStudentTrays',
      pushDatePeriod: 'mealControl/pushDatePeriod'
    }),

    ...mapGetters({
      getStudentParams: 'mealControl/getStudentParams'
    })
  }
}
</script>

<style scope lang="stylus">
  .student-trays-header
    display flex
    align-items center
    flex-wrap wrap
    @media only screen and (max-width: 768px)
      flex-direction column
</style>
